import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
	PerfectScrollbarConfigInterface,
	PerfectScrollbarComponent,
	PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import { ToastrService } from 'ngx-toastr';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';

import { AuthenticationService } from '../../../core/services/authentication.service';
// import { DashboardService } from '../../../core/services/dashboard.service';
// import { MailService } from '../../../core/services/mail.service';
import { HelperService } from '../../../core/services/helper.service';
import { TranslationService } from '../../../core/services/translation.service';
import { UserService } from '../../../core/services/user.service';

import { smoothlyMenu } from '../../../core/helpers/app.helper';
import { environment } from './../../../../environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DashboardStepperComponent } from 'src/app/modules/home/components/dashboard-stepper/dashboard-stepper.component';
import { CategorymasterService } from '../../services/categorymaster.service';
import { CartService } from '../../services/productShared.service';
// import { debug } from 'console';

declare var jQuery: any;

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
	private apiUrl = environment.apiUrl;
	bsModalRef?: BsModalRef;
	public scrollConfig: PerfectScrollbarConfigInterface = {};
	loginUser: any;
	// todaysActivities: any;
	// mails: any;
	latestVersion: any;
	translations: any;
	selectedLanguage: string;
	// interval: any;
	profileCompletion: any;
	userProfileImage: string = '../../../../../../isys_ui_v3/src/assets/img/profile_small.jpg';
	profileData: any;
	constructor(
		private categoryService: CategorymasterService,
		public translate: TranslateService,
		private modalService: BsModalService,
		private toastr: ToastrService,
		private authenticationService: AuthenticationService,
		private helperService: HelperService,
		// private dashboardService: DashboardService,
		// private mailService: MailService,
		private translationService: TranslationService,
		private userService: UserService,
		private productSharedService: CartService
	) {
		this.authenticationService.loginUser.subscribe(x => this.loginUser = x);

		if (this.loginUser) {
			this.selectedLanguage = this.loginUser.language;
		}
	}

	ngOnInit() {
		// this.getTodayActivities(8);
		// this.getUnReadMails(8);
		this.getAllActiveTranslations();
		this.loadBusinessAccount();
		// this.profileCompletion = Number(localStorage.getItem('profile_status_percentage')) || 0;
		this.profileCompletion = this.productSharedService.getProgress();

		// Reactively update when stepper changes it
		this.productSharedService.progress$.subscribe(value => {
			this.profileCompletion = value;
		});

	}

	openThemeSettings() {
		$('.theme-settings').toggleClass('open');
	}

	// getTodayActivities(length) {
	// 	this.dashboardService.getTodayActivities(length).subscribe(data => {
	// 		this.todaysActivities = data;
	// 	}, error => {
	// 		this.interval.unsubscribe();
	// 	});
	// }

	// getUnReadMails(length) {
	// 	this.mailService.getUnReadMails(length).subscribe(data => {
	// 		this.mails = data;
	// 	}, error => {
	// 		this.interval.unsubscribe();
	// 	});
	// }

	// executeCronJob(){
	// 	this.helperService.executeCronJob().subscribe(data => {})
	// }

	logout() {
		// this.interval.unsubscribe();
		this.authenticationService.logout();
	}

	getAllActiveTranslations() {
		this.translationService.getAllActiveTranslations().subscribe(data => {
			this.translations = data;
		});
	}

	changeLanguage(language: string) {
		this.translate.use(language);
		this.changeLocale(language);
	}

	changeLocale(locale: string) {
		this.selectedLanguage = locale;
		this.userService.changeLocale(locale).subscribe(data => { });
	}

	openStepperModal(): void {
		const initialState = {};
		this.bsModalRef = this.modalService.show(DashboardStepperComponent, {
			initialState,
			class: 'modal-lg modal-dialog-centered blur-modal'
		});
	}

	// click handler:
	onProfileProgressClick(): void {
		if (this.profileCompletion < 100) {
			this.openStepperModal();
		}
		// else do nothing (just show the bar)
	}

	loadBusinessAccount() {
		const business_account_id = localStorage.getItem("business_account_id");
		this.categoryService.getStepperData(business_account_id).subscribe({
			next: (res: any) => {
				this.profileData = res;
				console.log("new datatataaaaaaaaaaaaaaa", this.profileData)
			}
		})
	}
}
